import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RegionDto } from '../../../../core/data/new-dtos/region.dtos';

export interface RegionModalResult {
  action: 'save' | 'cancel';
  name?: string;
}

@Component({
  selector: 'app-region-modal',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './region-modal.component.html',
})
export class RegionModalComponent implements OnInit, AfterViewInit, OnDestroy {
  /** When set, the modal renames this region instead of creating one. */
  @Input() region?: RegionDto;
  @Output() closed = new EventEmitter<RegionModalResult>();

  name = '';

  constructor(private elementRef: ElementRef) { }

  get isEditMode(): boolean {
    return !!this.region;
  }

  ngOnInit(): void {
    this.name = this.region?.name ?? '';
  }

  ngAfterViewInit(): void {
    document.body.appendChild(this.elementRef.nativeElement);
  }

  ngOnDestroy(): void {
    const element = this.elementRef.nativeElement;
    if (element?.parentNode === document.body) {
      document.body.removeChild(element);
    }
  }

  get canSave(): boolean {
    return this.name.trim().length > 0;
  }

  onBackdropClick(event: MouseEvent): void {
    if ((event.target as HTMLElement).classList.contains('modal')) {
      this.onCancel();
    }
  }

  onCancel(): void {
    this.closed.emit({ action: 'cancel' });
  }

  onSave(): void {
    if (!this.canSave) return;
    this.closed.emit({ action: 'save', name: this.name.trim() });
  }
}
